var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSberbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#48B254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7581 4.1445L13.2896 4.62712L6.57788 8.45888L3.32888 6.58856L3.63263 5.985L6.57788 7.65956L12.7581 4.1445ZM11.4069 3.375L12.1202 3.73725L6.57788 6.90525L3.99713 5.44162L4.437 4.914L6.57788 6.13575L11.4075 3.375H11.4069ZM13.7604 5.12494L14.1548 5.65313L6.57788 9.98269L2.91881 7.90087L3.08588 7.23713L6.57788 9.22837L13.7604 5.12494ZM14.8534 7.07119C15.0761 7.695 15.1875 8.34806 15.1875 9.03206C15.1875 9.71606 15.0761 10.3804 14.8534 11.0233L14.7015 11.4311C14.3896 12.1626 13.9414 12.8281 13.3808 13.392C12.8134 13.949 12.1427 14.3899 11.4064 14.6897C10.6273 15.0216 9.82294 15.1875 8.99269 15.1875C8.15231 15.1875 7.34738 15.0216 6.57788 14.6897C5.85029 14.3821 5.18615 13.9421 4.61925 13.392C4.05215 12.8334 3.60302 12.1666 3.2985 11.4311C2.97788 10.6718 2.81194 9.85612 2.8125 9.03206V8.62481L6.57788 10.7522L14.5193 6.22631L14.8534 7.07119Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberbank);
export default __webpack_public_path__ + "static/media/sberbank.b442c5a1ec4c25e5df401212f2e990ae.svg";
export { ForwardRef as ReactComponent };